import { render, staticRenderFns } from "./xc-privacy-summary.vue?vue&type=template&id=1bb190b2&scoped=true"
import script from "./xc-privacy-summary.vue?vue&type=script&lang=js"
export * from "./xc-privacy-summary.vue?vue&type=script&lang=js"
import style0 from "./xc-privacy-summary.vue?vue&type=style&index=0&id=1bb190b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb190b2",
  null
  
)

export default component.exports